/* eslint-disable sort-keys */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-cycle */
import React from 'react'

import { AccordionItemComponent } from '../../components'
import AccordionsWrapper from '../../components/AccordionsWrapper/AccordionsWrapper'
import richTextRenderer from '../../components/RichTextParser/RichTextParser'
import { Heading } from '../../components/Typography'
import useMediaQuery from '../../hooks/useMediaQuery'
import {
  activeTitleClassName,
  borderHeading,
  cardContentStyling,
  cardTitleStyling,
  contentAccordionCardStyling,
  contentCardsContainer,
  contentCardsStyling,
  contentCardStyling,
  headerStyling,
  titleClassName,
} from './TreatmentDetailsFooter.module.css'

const TreatmentDetailsFooter = ({ contentCards, title, width }) => {
  const isDesktop = useMediaQuery('(min-width: 1200px)')

  return (
    <div className={contentCardsContainer}>
      {title && <Heading extraClassName={headerStyling}>{title}</Heading>}
      {title && <div className={borderHeading} />}
      <AccordionsWrapper className={contentCardsStyling} isDesktop={isDesktop}>
        {contentCards.length > 0 &&
          contentCards.map((card, index) => {
            const { treatmentcardcontent, treatmentcardtitle } = card
            return isDesktop ? (
              <div key={index} className={contentCardStyling} style={{ width }}>
                <h4 className={cardTitleStyling}>{treatmentcardtitle}</h4>
                <div className={cardContentStyling}>
                  {richTextRenderer(treatmentcardcontent)}
                </div>
              </div>
            ) : (
              <AccordionItemComponent
                key={index}
                contentClassname={contentAccordionCardStyling}
                extraActiveTitleClassName={activeTitleClassName}
                extraTitleClassname={titleClassName}
                item={{
                  title: treatmentcardtitle,
                  content: treatmentcardcontent,
                }}
              />
            )
          })}
      </AccordionsWrapper>
    </div>
  )
}

export default TreatmentDetailsFooter
